// React
import React from 'react';

// Packages
import t from 'prop-types';

// Utilities
import { useLabels, useFormat } from 'utilities/hooks';

// Components
import Card from 'components/_cardContentElements';

const ResultsAwardComponent = ({ item, theme = 'teal', wrap = false }) => {
    // ///////////////////
    // DATA
    // ///////////////////

    const { Description__c } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <Card.CardContentWrapper
            {...{
                wrap,
            }}>
            {/* Description */}
            {Description__c && (
                <Card.CardContentSection
                    {...{
                        theme,
                        wrap,
                    }}>
                    <p>{Description__c}</p>
                </Card.CardContentSection>
            )}

            {/* Details */}
            <ResultsAwardDetails {...{ item, theme, wrap }} />
        </Card.CardContentWrapper>
    );
};

const ResultsAwardDetails = ({ item, theme }) => {
    // ///////////////////
    // HOOKS
    // ///////////////////

    const { object } = useLabels();
    const format = useFormat();

    // ///////////////////
    // DATA
    // ///////////////////

    const { Year__c } = item;

    // ///////////////////
    // RENDER
    // ///////////////////

    return (
        <>
            {/* Various Info */}
            {[Year__c].some(x => x) && (
                <Card.CardContentPairBox>
                    {Year__c && (
                        <Card.CardContentPair
                            {...{
                                theme,
                                label: object.label(
                                    'Initiative_Result__c.Year__c___Award'
                                ),
                                value: format.year(Year__c),
                            }}
                        />
                    )}
                </Card.CardContentPairBox>
            )}
        </>
    );
};

ResultsAwardComponent.propTypes = {
    item: t.object,
};

ResultsAwardComponent.defaultProps = {};

export { ResultsAwardDetails };
export default ResultsAwardComponent;
